"use client";
import React, { useState } from "react";
import PropTypes from "prop-types";

import LoginForm from "components/login/forms/login";
import ForgotPasswordForm from "components/login/forgot-password-form";

const LoginStepModalContent = ({ handleLoginSuccessCallback }) => {
  const [forgotFormMail, setForgotFormMail] = useState("");
  const [isForgotPasswordForm, setIsForgotPasswordForm] = useState(false);

  const handleForgotButton = () => {
    const mail = localStorage.getItem("forgot-password-user");
    setForgotFormMail(mail);
    setIsForgotPasswordForm(!isForgotPasswordForm);
  };

  return !isForgotPasswordForm ? (
    <LoginForm modal handleForgotButton={handleForgotButton} successCallback={handleLoginSuccessCallback} />
  ) : (
    <ForgotPasswordForm modal defaultMail={forgotFormMail} handleBackButtonForgotForm={handleForgotButton} />
  );
};

LoginStepModalContent.propTypes = {
  handleLoginSuccessCallback: PropTypes.func,
};

export default LoginStepModalContent;
